import { StateCreator } from 'zustand';

import { RemoveFunctions } from '../../utils/types';

export type TableGroupExpansionsValue = {
  expanded: boolean;
  groupLevel: number;
};

export type TableGroupExpansionsSlice = {
  tableGroupExpansions: {
    [entityId: string]:
      | {
          [groupId: string]: TableGroupExpansionsValue;
        }
      | undefined;
  };

  setTableGroupExpansion(
    entityId: string,
    groupId: string,
    value: TableGroupExpansionsValue
  ): void;
  cloneTableGroupExpansions(entityIdFrom: string, entityIdTo: string): void;
  deleteTableGroupExpansions(entityId: string): void;
  resetTableGroupExpansionsSlice(): void;
};

const initialState: RemoveFunctions<TableGroupExpansionsSlice> = {
  tableGroupExpansions: {},
};

export const createTableGroupExpansionSlice: StateCreator<
  TableGroupExpansionsSlice,
  [],
  [],
  TableGroupExpansionsSlice
> = (set) => ({
  ...initialState,
  setTableGroupExpansion(
    entityId: string,
    groupId: string,
    value: TableGroupExpansionsValue
  ) {
    set((state) => {
      return {
        tableGroupExpansions: {
          ...state.tableGroupExpansions,
          [entityId]: {
            ...state.tableGroupExpansions[entityId],
            [groupId]: value,
          },
        },
      };
    });
  },

  cloneTableGroupExpansions(entityIdFrom: string, entityIdTo: string) {
    set((state) => {
      const expansions = { ...state.tableGroupExpansions[entityIdFrom] };
      return {
        tableGroupExpansions: {
          ...state.tableGroupExpansions,
          [entityIdTo]: expansions,
        },
      };
    });
  },

  deleteTableGroupExpansions(entityId: string) {
    set((state) => {
      const { [entityId]: _, ...tableGroupExpansions } =
        state.tableGroupExpansions;
      return {
        tableGroupExpansions,
      };
    });
  },

  resetTableGroupExpansionsSlice() {
    set({ ...initialState });
  },
});
